import React from "react";
import usePermisos from "helpers/usePermisos";
import { getPermisoDefinicion } from  "helpers/helpers"

function Permisos({ children, permiso }) {
    const { accesoDenegado } = usePermisos({
        modulo: getPermisoDefinicion(permiso)[
            "modulo"
        ],
        pantalla: getPermisoDefinicion(permiso)[
            "pantalla"
        ],
    });

    if(!accesoDenegado){
        return children
    }else{
        return null
    }
}

export default Permisos;
